import RefreshToken from '@src/api/RefreshToken';
import database from '@src/database/database';
import { ImmigrationStatus, PrimeStatus, Profile } from '@src/types';

import { ThunkResult } from '../types';

import {
  Actions,
  AUTH_LOGOUT,
  AUTH_SET_ACCESSES,
  AUTH_SET_IMMIGRATION,
  AUTH_SET_LABELS,
  AUTH_SET_LABELS_FILLED,
  AUTH_SET_PRIME,
  AUTH_SET_PROFILE,
  AUTH_SET_REFRESHING,
  AUTH_SET_SETUP_COMPLETE,
  AUTH_SET_TOKENS,
  Labels,
  Tokens,
} from './types';

export const setTokens = (
  tokens: Tokens & { setupComplete?: boolean }
): Actions => {
  return {
    type: AUTH_SET_TOKENS,
    payload: tokens,
  };
};

export const setProfile = (profile: Profile): Actions => {
  return {
    type: AUTH_SET_PROFILE,
    payload: profile,
  };
};

export const setPrimeStatus = (primeStatus: PrimeStatus): Actions => {
  return {
    type: AUTH_SET_PRIME,
    payload: primeStatus,
  };
};
export const setAllStatus = (allStatus: PrimeStatus[]): Actions => {
  return {
    type: AUTH_SET_ACCESSES,
    payload: allStatus,
  };
};
export const setImmigrationStatus = (
  immigrationStatus: ImmigrationStatus
): Actions => {
  return {
    type: AUTH_SET_IMMIGRATION,
    payload: immigrationStatus,
  };
};
export const setSetupComplete = (payload: boolean): Actions => {
  return {
    type: AUTH_SET_SETUP_COMPLETE,
    payload,
  };
};

export const setLabelsFilled = (payload: boolean): Actions => {
  return {
    type: AUTH_SET_LABELS_FILLED,
    payload,
  };
};

export const setLabels = (payload: Labels): Actions => {
  return {
    type: AUTH_SET_LABELS,
    payload,
  };
};

export const logout = (): ThunkResult<void> => {
  return async (dispatch) => {
    await database.action(async () => {
      await database.unsafeResetDatabase();
    });

    dispatch({
      type: AUTH_LOGOUT,
    });
  };
};

export const refreshToken = (): ThunkResult<void> => {
  return async (dispatch, getState) => {
    if (!getState().authentication.refreshing) {
      console.log('Refreshing');
      await dispatch({
        type: AUTH_SET_REFRESHING,
        payload: true,
      });

      try {
        const response = await RefreshToken(
          getState().authentication.refreshToken
        );
        const accessToken = response.headers['x-auth-token'];

        await dispatch(
          setTokens({
            accessToken,
            refreshToken: response.data.refreshToken,
            region: response.data.region,
          })
        );

        await dispatch({
          type: AUTH_SET_REFRESHING,
          payload: false,
        });
      } catch (e) {
        console.log('user should logout');
        await dispatch(logout());
      }
    }
  };
};
